// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__ebb3+","formLabel":"Radio_formLabel__CdpWW"};